import { showErrorMessage } from 'actions/messages';
import { closeoutCatsApi } from 'services/api/closeout-cats-api';
import { closeoutApi } from 'services/api/closeout-api';
import { closeoutContributorsApi } from 'services/api/closeout-contributors-api';
import { closeoutContributorCatsApi } from 'services/api/closeout-contributor-cats-api';
import { closeoutManualsApi } from 'services/api/closeout-manuals-api';
import { buildingsApi } from 'services/api/buildings-api';
import {
  CLOSEOUT_CATS_SET,
  CLOSEOUT_SET,
  CLOSEOUT_CONTRIBS_SET,
  CLOSEOUT_CONTRIB_SET,
  CLOSEOUT_PERCENTAGE_SET,
  CLOSEOUT_MANUALS_SET,
  CLOSEOUT_MANUAL_SET,
  CLOSEOUT_MANUAL_UPDATE,
  CLOSEOUT_MANUAL_DELETE,
} from 'components/admin/projects/details/project-closeout/store/action-types';

export function loadCloseoutCatsSuccess(closeoutCats) {
  return {
    type: CLOSEOUT_CATS_SET,
    payload: closeoutCats,
  };
}

export function loadCloseoutCatsRequest() {
  return (dispatch) => {
    return closeoutCatsApi.getCloseoutCats().then((response) => {
      if (response.ok) {
        dispatch(loadCloseoutCatsSuccess(response.closeoutCats));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadCloseoutSuccess(closeout) {
  return {
    type: CLOSEOUT_SET,
    payload: closeout,
  };
}

export function loadCloseoutRequest(projectId) {
  return (dispatch) => {
    return closeoutApi.getCloseout(projectId).then((response) => {
      if (response.ok) {
        dispatch(loadCloseoutSuccess(response.closeout));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function updateCloseout(projectId, values) {
  return (dispatch) => {
    return closeoutApi.updateCloseout(projectId, values).then((response) => {
      if (response.ok) {
        dispatch(loadCloseoutSuccess(response.closeout));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function requestCloseout(projectId) {
  return (dispatch) => {
    return closeoutApi.requestCloseout(projectId).then((response) => {
      if (response.ok) {
        dispatch(loadCloseoutSuccess(response.closeout));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadCloseoutContribsSuccess(
  closeoutContribs,
  currentPage,
  total,
  pageSize
) {
  return {
    type: CLOSEOUT_CONTRIBS_SET,
    payload: { closeoutContribs, currentPage, total, pageSize },
  };
}

export function loadCloseoutContribsRequest(projectId, page) {
  return (dispatch) => {
    return closeoutContributorsApi
      .getCloseoutContributors(projectId, page)
      .then((response) => {
        if (response.ok) {
          dispatch(
            loadCloseoutContribsSuccess(
              response.closeoutContributors,
              page,
              response.total,
              response.pageSize
            )
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateCloseoutContribSuccess(closeoutContrib) {
  return {
    type: CLOSEOUT_CONTRIB_SET,
    payload: closeoutContrib,
  };
}

export function updateCloseoutContrib(projectId, closeoutContrib, values) {
  return (dispatch) => {
    return closeoutContributorsApi
      .updateCloseoutContributor(projectId, closeoutContrib, values)
      .then((response) => {
        if (response.ok) {
          dispatch(updateCloseoutContribSuccess(response.closeoutContributor));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function closeoutPercentageSuccess(percentage) {
  return {
    type: CLOSEOUT_PERCENTAGE_SET,
    payload: percentage,
  };
}

export function closeoutPercentage(projectId) {
  return (dispatch) => {
    return closeoutContributorCatsApi
      .getCompletedPercentage(projectId)
      .then((response) => {
        if (response.ok) {
          dispatch(closeoutPercentageSuccess(response.completedPercentage));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateBuilding(buildingId, values) {
  return (dispatch) => {
    return buildingsApi.updateBuilding(buildingId, values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadCloseoutManualsSuccess(
  closeoutManuals,
  closeoutManualsCurrentPage,
  closeoutManualsTotal,
  closeoutManualsPageSize
) {
  return {
    type: CLOSEOUT_MANUALS_SET,
    payload: {
      closeoutManuals,
      closeoutManualsCurrentPage,
      closeoutManualsTotal,
      closeoutManualsPageSize,
    },
  };
}

export function loadCloseoutManualsRequest(projectId, page) {
  return (dispatch) => {
    return closeoutManualsApi
      .getCloseoutManuals(projectId, page)
      .then((response) => {
        if (response.ok) {
          dispatch(
            loadCloseoutManualsSuccess(
              response.closeoutManuals,
              page,
              response.total,
              response.pageSize
            )
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function createCloseoutManualSuccess(closeoutManual) {
  return {
    type: CLOSEOUT_MANUAL_SET,
    payload: closeoutManual,
  };
}

export function createCloseoutManual(projectId) {
  return (dispatch) => {
    return closeoutManualsApi
      .createCloseoutManual(projectId)
      .then((response) => {
        if (response.ok) {
          dispatch(createCloseoutManualSuccess(response.closeoutManual));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadCloseoutManualSuccess(closeoutManual) {
  return {
    type: CLOSEOUT_MANUAL_UPDATE,
    payload: closeoutManual,
  };
}

export function loadCloseoutManual(projectId, id) {
  return (dispatch) => {
    return closeoutManualsApi
      .getCloseoutManual(projectId, id)
      .then((response) => {
        if (response.ok) {
          dispatch(loadCloseoutManualSuccess(response.closeoutManual));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function deleteCloseoutManualSuccess(id) {
  return {
    type: CLOSEOUT_MANUAL_DELETE,
    payload: id,
  };
}

export function deleteCloseoutManual(projectId, id) {
  return (dispatch) => {
    return closeoutManualsApi
      .deleteCloseoutManual(projectId, id)
      .then((response) => {
        if (response.ok) {
          dispatch(deleteCloseoutManualSuccess(id));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/store/actions.js